import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AccessDeniedPage} from 'frontend/components/access_denied/access_denied';
import {AppRoutes} from 'frontend/constants/routes';
import {LoginPage} from 'frontend/login/login';
import {FEATURE_FLAGS} from 'frontend/model_builder/feature_flags';
import {TapestryRouteHierarchy} from 'frontend/platform/tapestry_route_hierarchy';
import {authGuard} from 'frontend/services/auth_guard';
import {featureFlagGuard} from 'frontend/services/feature_flag_guard';
import {googleMapsLoaderGuard} from 'frontend/services/map_loader_guard';
import {canUserAccessDeniedRoute, canUserAccessRoute} from 'frontend/services/route_access_guard';

export const routes: Routes = TapestryRouteHierarchy.fromRoutes([
  {
    path: AppRoutes.LOGIN.app,
    component: LoginPage,
    title: AppRoutes.LOGIN.title,
  },
  {
    path: AppRoutes.ACCESS_DENIED.app,
    component: AccessDeniedPage,
    title: AppRoutes.ACCESS_DENIED.title,
    canActivate: [canUserAccessDeniedRoute],
    data: {
      appPathIdentifier: AppRoutes.ACCESS_DENIED.app,
    },
  },
  {
    path: AppRoutes.GPT.app,
    data: {
      appTitle: AppRoutes.GPT.pageLayoutTitle,
      pageLayoutTitle: AppRoutes.GPT.pageLayoutTitle,
      appPathIdentifier: AppRoutes.GPT.app,
    },
    canActivate: [authGuard, googleMapsLoaderGuard, canUserAccessRoute],
    loadChildren: () => import('frontend/gpt/routing').then((v) => v.routes),
  },
  {
    path: AppRoutes.GPTD.app,
    data: {
      pageLayoutTitle: AppRoutes.GPTD.pageLayoutTitle,
      appTitle: AppRoutes.GPTD.pageLayoutTitle,
      appPathIdentifier: AppRoutes.GPTD.app,
    },
    canActivate: [authGuard, googleMapsLoaderGuard, canUserAccessRoute],
    loadChildren: () => import('frontend/gptd/routing').then((v) => v.routes),
  },
  {
    path: AppRoutes.HYPERQUEUE.app,
    data: {
      pageLayoutTitle: AppRoutes.HYPERQUEUE.pageLayoutTitle,
      appTitle: AppRoutes.HYPERQUEUE.pageLayoutTitle,
      appPathIdentifier: AppRoutes.HYPERQUEUE.app,
    },
    canActivate: [authGuard, googleMapsLoaderGuard, canUserAccessRoute],
    loadChildren: () => import('frontend/hyperqueue/routing').then((v) => v.routes),
  },
  {
    path: AppRoutes.SIMULATIONS.app,
    data: {
      pageLayoutTitle: AppRoutes.SIMULATIONS.pageLayoutTitle,
      appTitle: AppRoutes.SIMULATIONS.pageLayoutTitle,
      appPathIdentifier: AppRoutes.SIMULATIONS.app,
    },
    canActivate: [authGuard, googleMapsLoaderGuard, canUserAccessRoute],
    loadChildren: () => import('frontend/simulations/routing').then((v) => v.routes),
  },
  {
    path: AppRoutes.HOSTING_CAPACITY.app,
    data: {
      appTitle: AppRoutes.HOSTING_CAPACITY.title,
      pageLayoutTitle: AppRoutes.HOSTING_CAPACITY.title,
      appPathIdentifier: AppRoutes.HOSTING_CAPACITY.app,
    },
    canActivate: [authGuard, googleMapsLoaderGuard, canUserAccessRoute],
    loadChildren: () => import('frontend/hosting_capacity/routing').then((v) => v.routes),
  },
  {
    path: AppRoutes.MODEL_BUILDER.app,
    data: {
      pageLayoutTitle: AppRoutes.MODEL_BUILDER.pageLayoutTitle,
      appTitle: AppRoutes.MODEL_BUILDER.pageLayoutTitle,
      appPathIdentifier: AppRoutes.MODEL_BUILDER.app,
      appPath: '',
    },
    canActivate: [
      authGuard,
      googleMapsLoaderGuard,
      featureFlagGuard(FEATURE_FLAGS.MODEL_BUILDER),
      canUserAccessRoute,
    ],
    loadChildren: () => import('frontend/model_builder/routing').then((v) => v.routes),
  },
  {
    path: '',
    redirectTo: AppRoutes.GPT.path,
    pathMatch: 'full',
  },
  {path: '**', redirectTo: AppRoutes.GPT.path},
]);

/**
 * The routing module for the application.
 */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
